import React from "react";
import { Route, Routes } from "react-router-dom";
import ClientRegistration from "../pages/start/ClientRegistration";
import LawFirmRegistration from "../pages/start/LawFirmRegistration";
import PublicRoute from "./PublicRoute";

import HomeEcommerce from "@/pages/Ecommerce/HomeEcommerce";
import LawFirmListings from "@/pages/Ecommerce/parts/LawFirmListings";
import PerfilBufetePage from "@/pages/Ecommerce/parts/PerfilBufetePage";
import AbogadosRegistro from "@/pages/start/AbogadosRegistro";


import Login from "@/pages/start/Login";

const PublicRoutes = () => (
  <Routes>
    {/* Rutas públicas con protección para login */}
    <Route element={<PublicRoute restricted={true} />}>
      <Route path="/login" element={<Login />} />
    </Route>
    <Route path="/registro-cliente" element={<ClientRegistration />} />
    <Route path="/registro-bufete" element={<LawFirmRegistration />} />
    <Route path="/registro-abogados" element={<AbogadosRegistro />} />

    {/* Rutas para HomeEcommerce */}
    <Route path="/HomeEcommerce/*" element={<HomeEcommerce />}>
      <Route path="LawFirmListings" element={<LawFirmListings />} />

      <Route path="PerfilBufetePage/:id" element={<PerfilBufetePage />} />
    </Route>
  </Routes>
);

export default PublicRoutes;
